import { Component, FunctionalComponent, h } from 'preact';
import {
  IUserDropdownLink,
  IUserDropdownProps
} from '../sgwt-super-header.types';

interface IPropsDropdownItem {
  label: string;
  onClick: () => void;
  target?: string;
  value: string;
}

const DropdownItem: FunctionalComponent<IPropsDropdownItem> = ({
  label,
  onClick,
  target,
  value
}: IPropsDropdownItem) => (
  <li role="presentation">
    <a
      href={value}
      onClick={onClick}
      role="menuitem"
      tabIndex={-1}
      target={target}
    >
      {label}
    </a>
  </li>
);

function constructMenuItems(
  props: IUserDropdownProps,
  addDelimiter: boolean,
  handleClick: () => void
) {
  let items;
  let divider;
  // Check if we have custom links to add after the default "user profile" and "change password" links.
  if (props.userDropdownLinks && props.userDropdownLinks.length > 0) {
    if (addDelimiter) {
      divider = <li role="separator" class="divider" />;
    }
    items = props.userDropdownLinks.map((link: IUserDropdownLink) => {
      if (link.target) {
        return (
          <DropdownItem
            label={link.label}
            value={link.link}
            target={link.target}
            onClick={() => { handleClick(); props.onUserDropdownLinkClicked(link); }}
          />
        );
      }
      return (
        <DropdownItem
          label={link.label}
          value={link.link}
          onClick={() => { handleClick(); props.onUserDropdownLinkClicked(link); }}
        />
      );
    });
  }
  return [items, divider];
}

interface IUserDropdownState {
  isOpen: boolean;
}

export default class UserDropdown extends Component<
  IUserDropdownProps,
  IUserDropdownState
> {
  private handler?: HTMLLIElement;

  constructor(props: IUserDropdownProps) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  render(
    props: IUserDropdownProps,
    { isOpen }: IUserDropdownState
  ): JSX.Element | null {
    if (!props.user || !props.user.mail) {
      return null;
    }
    // let userProfileLinkItem;
    let changePasswordLinkItem;
    let addDelimiter = false;
    let hasItemsInMenu =
      props.userDropdownLinks && props.userDropdownLinks.length > 0;

    const chagePasswordlink = props.authentication
      ? props.authentication.changePasswordLink
      : null;
    if (chagePasswordlink) {
      addDelimiter = true;
      hasItemsInMenu = true;
      changePasswordLinkItem = (
        <DropdownItem
          label={props.labels.changePassword}
          onClick={this.handleClick}
          value={chagePasswordlink}
        />
      );
    }

    const [items, divider] = constructMenuItems(
      props,
      addDelimiter,
      this.handleClick
    );

    if (!hasItemsInMenu) {
      return (
        <li className="hidden-xs" id="sgwt-super-header-user-info">
          <i className="fa fa-user" /> {props.user.mail}
        </li>
      );
    }

    return (
      <li
        className={`hidden-xs ${isOpen ? 'open ' : ''}dropdown`}
        ref={(handler: HTMLLIElement) => {
          this.handler = handler;
        }}
      >
        <a
          aria-expanded={isOpen}
          aria-haspopup="true"
          className="dropdown-toggle sgwt-super-header-user-dropdown"
          id="sgwt-super-header-user-dropdown"
          href="#"
          onClick={this.handleDropdownToggle}
          role="button"
        >
          {`${props.user.mail} `}
          <span className="caret" />
        </a>
        <ul
          role="menu"
          className="dropdown-menu"
          aria-labelledby="sgwt-super-header-user-dropdown"
        >
          {props.defaultAccountCenter && (
            <DropdownItem
              label={props.labels.accountCenter}
              onClick={this.handleClick}
              value={props.defaultAccountCenter}
            />
          )}
          {changePasswordLinkItem}
          {divider}
          {items}
        </ul>
      </li>
    );
  }

  private handleClick = () => {
    this.handleClose();
  };

  private handleClose = (event?: Event) => {
    if (event) {
      event.preventDefault();
    }
    document.removeEventListener('click', this.handleOutsideClick, false);
    document.removeEventListener('touchend', this.handleOutsideClick, false);
    document.removeEventListener('keydown', this.handleKeydown, false);
    this.setState({ isOpen: false });
  };

  private handleDropdownToggle = (event: Event) => {
    if (event) {
      event.preventDefault();
    }
    const { isOpen } = this.state;
    if (isOpen) {
      this.handleClose();
    } else {
      document.addEventListener('click', this.handleOutsideClick, false);
      document.addEventListener('touchend', this.handleOutsideClick, false);
      document.addEventListener('keydown', this.handleKeydown, false);
      this.setState({ isOpen: true });
    }
  };

  private handleKeydown = (event: KeyboardEvent) => {
    const { isOpen } = this.state;
    if (isOpen && (event.key === 'Escape' || event.which === 27)) {
      this.handleClose();
    }
  };

  private handleOutsideClick = (event: Event) => {
    if (this.handler && !this.handler.contains(event.target as Node)) {
      this.handleClose();
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-super-header/components/UserDropdown.tsx